/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:04 2020/10/7
 */

import * as Vue from "vue-tsx-support";
import {Component, Prop} from 'vue-property-decorator'
import "vue-tsx-support/enable-check"
import './iconCustom.less'
interface IconCustomProps {
	type: string
	color?: string
	size?: number
}

@Component({})
export default class IconCustom extends Vue.Component<IconCustomProps> {

	@Prop({
		type: String
	})
	type?: string

	@Prop({
		type: String,
		default: '#000'
	})
	color?: string

	@Prop({
		type: Number,
		default: 12
	})
	size?: number

	render (h) {
		return (
			<i class={"wqms-icon-custom wqms-font " + this.type} style={{color: this.color, fontSize: this.size}}></i>
		);
	}
}
